import { render, staticRenderFns } from "./Zou.vue?vue&type=template&id=e48c3068&scoped=true&"
import script from "./Zou.vue?vue&type=script&lang=js&"
export * from "./Zou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48c3068",
  null
  
)

export default component.exports